/* =========================================================
   SANE SEITY — Theme JavaScript
   ========================================================= */

(function () {
  'use strict';

  /* --- Mobile nav ----------------------------------------- */
  const mobileToggle = document.querySelector('.header-mobile-toggle');
  const mobileNav    = document.querySelector('.header-mobile-nav');
  const mobileClose  = document.querySelector('.header-mobile-nav-close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* --- Category toggle ------------------------------------ */
  const categoryToggle = document.querySelector('.category-toggle');
  const categoryList   = document.querySelector('.category-list');

  if (categoryToggle && categoryList) {
    categoryToggle.addEventListener('click', () => {
      categoryToggle.classList.toggle('is-open');
      categoryList.classList.toggle('is-open');
    });
  }

  /* --- Accordion ------------------------------------------ */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.accordion-item.is-open').forEach(el => {
        el.classList.remove('is-open');
      });

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  /* --- Product media gallery ------------------------------ */
  const thumbs  = document.querySelectorAll('.product-media-thumb');
  const mainImg = document.querySelector('.product-media-main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;

      if (mainImg && src) {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
      }

      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* --- Variant / size selection --------------------------- */
  const sizeBtns = document.querySelectorAll('.size-btn');
  const variantIdInput = document.querySelector('[name="id"]');

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-unavailable')) return;

      sizeBtns.forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      if (variantIdInput && btn.dataset.variantId) {
        variantIdInput.value = btn.dataset.variantId;
      }

      // Update price display
      const priceEl = document.querySelector('.product-details-price');
      if (priceEl && btn.dataset.price) {
        priceEl.textContent = btn.dataset.price;
      }
    });
  });

  /* --- Newsletter form ------------------------------------ */
  const newsletterForms = document.querySelectorAll('.newsletter-form');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('.newsletter-input');
      const submit = form.querySelector('.newsletter-submit');

      if (!input || !input.value.trim()) {
        e.preventDefault();
        return;
      }

      submit.textContent = 'Submitted';
      submit.disabled = true;
    });
  });

})();
